import axios from 'axios';

var preloadService = (function() {

  /**
   * @param {Route} to
   * @returns {Promise<Route>|boolean}
   */
  var loadPreloads = function(to) {
    if (to.meta.preloads == undefined) { return false }
    return _handlePreloads(to.meta.preloads, to);
  }

  /**
   * @param {array<string>} preloads
   * @param {Route} to
   * @returns {Promise<Route>}
   * @private
   */
  var _handlePreloads = async function(preloads, to) {

    const preloadsDataObj = {};
    for (const preloadPath of preloads) {
      const response = await axios.get(`/rest/v4/${preloadPath}`);
      preloadsDataObj[preloadPath] = response.data;
    }

    return _setPreloadsDataAsProp(preloadsDataObj, to);
  }

  /**
   * @param {object} preloadsDataObj
   * @param {Route} to
   * @returns {Route}
   * @private
   */
  var _setPreloadsDataAsProp = function(preloadsDataObj, to) {
    to.params.preloads = preloadsDataObj;
    return to;
  }

  return { loadPreloads: loadPreloads }
})();

export default preloadService;
